export function groupModels(models) {
    const result = [];

    const groupedModels = {};
    for (const model of models) {
        const groupName = model.group === null ? 'Другие' : model.group;
        if (!groupedModels[groupName]) {
            groupedModels[groupName] = [];
        }
        groupedModels[groupName].push(model);
    }
    result.push(...Object.entries(groupedModels)
        .map(([groupName, models]) => ({
            name: groupName,
            // Сортируем модели внутри каждой группы по названию
            models: models.sort((a, b) => a.name.localeCompare(b.name))
        }))
        .sort((a, b) => {
            if (a.name === 'OpenAi') return -1;
            if (b.name === 'OpenAi') return 1;
            // "Другие" всегда в конце
            if (a.name === 'Другие') return 1;
            if (b.name === 'Другие') return -1;
            // Остальные группы сортируем по алфавиту
            return a.name.localeCompare(b.name);
        }));

    return result;
}